/* eslint-disable max-len */
/* eslint-disable */
import React from 'react';
import { withRouter, Switch, Route, Redirect, NavLink } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';

import * as actions from './actions';
import * as c from './constant';

// import BPLSNewTransactionOld from './new/container/TransactionContainer';
// import BPLSReNewTransactionOld from './renewal/container/TransactionContainer';

// import BusinessTax from './businessTax/container/BusinessTaxContainer';
// import TransactionContainer from './transactions/TransactionsContainer';
// import SettingsContainer from './settings/SettingsContainer';

// import ApplicationContainer from './applications/container/ApplicationContainer';
// import TaxRevenuesContainer from './newTaxRevenues/TaxRevenuesContainer';
// import BusinessContainer from './business/BusinessContainer';
// import EBossContainer from './EBossContainer';
// import BplsReportsContainer from './components/reports/containers/BplsReportsContainer';
import AuditLogContainer from './audit/reports/containers/AuditLogContainer';
// import ExportLogContainer from './audit/reports/containers/ExportLogContainer';
import AuditLogReport from 'modules/reports/transactions/containers/AuditLogReport';

function AuditContainer({ match }) {
  const permissions = getJson('permissions');
  const auditRoles = [
    'VIEW GENERAL AUDITS',
    'VIEW BPLS AUDITS',
    'VIEW BIRTH CERTIFICATE AUDITS',
    'VIEW DEATH CERTIFICATE AUDITS',
    'VIEW MARRIAGE CERTIFICATE AUDITS',
    'VIEW CEDULA AUDITS',
    'VIEW EXPORTS AUDITS',
  ];
  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">Audit Logs</div>
        <SideScrollingTab dragToScroll hideScrollButtons>
          <div className="generic-module-nav">
            {Acl(permissions, ['VIEW GENERAL AUDITS']) && (
              <NavLink
                exact
                className="nav-link"
                activeClassName="active"
                to="/audits/transactions/GENERAL"
              >
                General
              </NavLink>
            )}

            {Acl(permissions, ['VIEW BPLS AUDITS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/audits/transactions/BPLS_AUDIT"
              >
                BPLS
              </NavLink>
            )}

            {Acl(permissions, ['VIEW BIRTH CERTIFICATE AUDITS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/audits/transactions/BIRTH_CERTIFICATE_AUDIT"
              >
                Birth Certificate
              </NavLink>
            )}

            {Acl(permissions, ['VIEW DEATH CERTIFICATE AUDITS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/audits/transactions/DEATH_CERTIFICATE_AUDIT"
              >
                Death Certificate
              </NavLink>
            )}

            {Acl(permissions, ['VIEW MARRIAGE CERTIFICATE AUDITS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/audits/transactions/MARRIAGE_CERTIFICATE_AUDIT"
              >
                Marriage Certificate
              </NavLink>
            )}

            {Acl(permissions, ['VIEW CEDULA AUDITS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/audits/transactions/CEDULA_AUDIT"
              >
                Cedula
              </NavLink>
            )}

            {Acl(permissions, ['VIEW EXPORTS AUDITS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/audits/export"
              >
                Export
              </NavLink>
            )}
          </div>
        </SideScrollingTab>
        <Switch>
          {permissions.map((permission) => {
            if (auditRoles.includes(permission)) {
              return (
                <Route
                  key={permission}
                  exact
                  path={`${match.path}/transactions/:mainModule`}
                  component={AuditLogContainer}
                />
              );
            }
          })}
          <Route
            exact
            path={`${match.path}/export`}
            component={AuditLogReport}
          />
        </Switch>
      </div>
    </>
  );
}

AuditContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionListCount: _.get(api, `${c.GET_TRANSACTION_COUNTS}.res`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AuditContainer);
